module.exports = __webpack_public_path__ + "img/border_octagonal.77501629.svg";